import React, { useState } from 'react';
import { vehicleApi } from '../../api/portal';
import usePortalQuery from '../../hooks/usePortalQuery';
import { QueryStatus } from '../../components/portal/PortalUI';

export default function CarProfileSelector({ selected, onChange, disabled }) {
  const [search, setSearch] = useState('');
  const [offset, setOffset] = useState(0);
  const query = usePortalQuery(['upload-car-selector', search, offset],
    (signal) => vehicleApi.list({ q: search, offset, limit: 50 }, signal));
  const profiles = (query.data?.vehicle_profiles || []).map((item) => item.profile);
  const options = selected && !profiles.some((profile) => profile.id === selected.id) ? [selected, ...profiles] : profiles;
  return <section className="upload-car-selector">
    <h2>Car profile (optional)</h2>
    <label>Search car profiles<input value={search} disabled={disabled}
      onChange={(event) => { setSearch(event.target.value); setOffset(0); }} placeholder="Plate, make, or model" /></label>
    {query.loading ? <p role="status">Loading car profiles...</p> : <QueryStatus query={query} />}
    <label>Attach photos to car profile<select value={selected?.id || ''} disabled={disabled}
      onChange={(event) => onChange(options.find((profile) => profile.id === event.target.value) || null)}>
      <option value="">Create a new car profile from these photos</option>
      {options.map((profile) => <option key={profile.id} value={profile.id}>
        {profile.plate_number || profile.id} - {[profile.Make, profile.Model].filter(Boolean).join(' ') || 'Unknown make/model'} ({profile.id})
      </option>)}
    </select></label>
    <p>Optional: choose an existing car, including cars without photos. Every four-photo batch becomes a reservation of the selected car. Without a selection, each batch creates a new profile from OCR, even if that plate already exists.</p>
    <p>The selection applies to all batches in this upload. For different cars, upload them separately. OCR uses the fourth photo; selected cars do not require successful OCR.</p>
    {query.data && <div className="section-actions">
      <button type="button" disabled={disabled || offset === 0} onClick={() => setOffset(Math.max(0, offset - 50))}>Previous cars</button>
      <span>{query.data.count} matching cars</span>
      <button type="button" disabled={disabled || offset + 50 >= query.data.count} onClick={() => setOffset(offset + 50)}>Next cars</button>
    </div>}
  </section>;
}
